import Vue from "vue";
import Router from "vue-router";
import { store } from "./store";

Vue.use(Router);

let router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/Home.vue"),
    },
    {
      path: "*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/404.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
    },
    {
      path: "/stats",
      name: "stats",
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(/* webpackChunkName: "stats" */ "./views/Stats.vue"),
    },

    // AP
    // ap new
    {
      path: "/accept-protocols/new",
      name: "accept-protocol-new",
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "apNew" */ "./views/accept-protocol/apCreate.vue"
        ),
    },
    // ap list
    {
      path: "/accept-protocols",
      alias: "/accept-protocols/pending",
      name: "accept-protocol-list",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "apList" */ "./views/accept-protocol/apList.vue"
        ),
    },
    // ap Finalized list
    {
      path: "/accept-protocols/finalized",
      name: "accept-protocol-finalized-list",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "apFinalizedList" */ "./views/accept-protocol/apFinalizedList.vue"
        ),
    },
    // ap by id
    {
      path: "/accept-protocols/:id",
      name: "accept-protocol-by-id",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "apShow" */ "./views/accept-protocol/apShow.vue"
        ),
    },

    // ap finalized by id
    {
      path: "/accept-protocol/:id/finalized",
      name: "accept-protocol-finalized-by-id",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "apFinalizedShow" */ "./views/accept-protocol/apFinalizedShow.vue"
        ),
    },

    // AP TEMPLATES
    // apt new
    {
      path: "/accept-protocol-template/new",
      name: "accept-protocol-template-new",
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "aptNew" */ "./views/accept-protocol-template/aptCreate.vue"
        ),
    },

    // apt list
    {
      path: "/accept-protocol-templates",
      name: "accept-protocol-template-list",
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "aptList" */ "./views/accept-protocol-template/aptList.vue"
        ),
    },
    // apt edit
    {
      path: "/accept-protocol-template/:id/edit",
      name: "accept-protocol-template-edit-by-id",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "aptEdit" */ "./views/accept-protocol-template/aptEdit.vue"
        ),
    },

    // user settings
    {
      path: "/user-settings",
      name: "user-settings",
      meta: {
        requiresAuth: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "userSettings" */ "./views/userSettings.vue"
        ),
    },

    // Customer Generated Link
    {
      path: "/closure/:slug",
      name: "closure",
      props: true,
      meta: {
        customerArea: true,
      },
      component: () =>
        import(/* webpackChunkName: "closure" */ "./views/closure.vue"),
    },
  ],
});

// middleware for checking if the route should be protected
// if protected route check if the user has been logged in
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters["account/isLoggedIn"]) {
      next();
      return;
    }

    // to be used in store/account.js for re-routing user after successfully logged in
    localStorage.setItem("requestedURL", to.fullPath);

    next("/login");
  } else {
    next();
  }
});

export default router;
